import { render } from "./EntitySelectorVeiculoTrator.vue?vue&type=template&id=5bfa11f6"
import script from "./EntitySelectorVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script